export default function ExtrasPorUnidad({
  producto,
  esJugo,
  loading,
  extrasBD,
  configPorUnidad,
  setConfigPorUnidad,
  incExtraUnidad,
  decExtraUnidad,
}) {
  return (
    <div className="space-y-3">
      <p className="font-semibold text-orange-400">
        Personalizar cada uno
      </p>

      {loading ? (
        <p className="text-gray-400 text-sm">
          Cargando adicionales...
        </p>
      ) : (
        configPorUnidad.map((u, idx) => (
          <div
            key={idx}
            className="bg-[#0f0f0f] border border-white/10 rounded-xl p-4 space-y-3"
          >
            <p className="font-bold text-sm">
              {producto.nombre} #{idx + 1}
            </p>

            {/* BASE (solo jugos) */}
            {esJugo && (
              <select
                value={u.base}
                onChange={(e) =>
                  setConfigPorUnidad((prev) =>
                    prev.map((x, i) =>
                      i === idx
                        ? { ...x, base: e.target.value }
                        : x
                    )
                  )
                }
                className="w-full bg-[#1a1a1a] p-3 rounded"
              >
                <option value="">Selecciona Agua o Leche</option>
                <option value="Agua">Agua</option>
                <option value="Leche">Leche</option>
              </select>
            )}

            {/* EXTRAS */}
            {extrasBD.length === 0 ? (
              <p className="text-gray-400 text-sm">
                No hay adicionales para este producto
              </p>
            ) : (
              <div className="flex flex-nowrap gap-3 overflow-x-auto pb-2">
                {extrasBD.map((e) => {
                  const q = (u.extrasQty || {})[e.id] || 0;

                  return (
                    <div
                      key={e.id}
                      className="min-w-[190px] flex-shrink-0
                                 bg-[#111]
                                 border border-white/10
                                 rounded-xl p-3"
                    >
                      <p className="font-semibold text-sm">
                        {e.nombre}
                      </p>

                      <p className="text-orange-400 text-sm">
                        +$
                        {Number(e.precio).toLocaleString(
                          "es-CO"
                        )}
                      </p>

                      <div className="flex items-center gap-2 mt-3">
                        <button
                          onClick={() =>
                            decExtraUnidad(idx, e.id)
                          }
                          disabled={q === 0}
                          className={`px-2 rounded text-white ${
                            q === 0
                              ? "bg-gray-700"
                              : "bg-red-500"
                          }`}
                        >
                          -
                        </button>

                        <span className="font-bold w-4 text-center">
                          {q}
                        </span>

                        <button
                          onClick={() =>
                            incExtraUnidad(idx, e.id)
                          }
                          className="bg-green-500 px-2 rounded text-white"
                        >
                          +
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}

            {/* NOTA */}
            <textarea
              value={u.nota}
              onChange={(e) =>
                setConfigPorUnidad((prev) =>
                  prev.map((x, i) =>
                    i === idx
                      ? { ...x, nota: e.target.value }
                      : x
                  )
                )
              }
              placeholder="Nota para este producto (opcional)"
              className="w-full bg-[#1a1a1a] p-3 rounded"
            />
          </div>
        ))
      )}
    </div>
  );
}
